<template>
    <div>
        <div v-if="forgottenPasswordSent">
            Email pro obnovu hesla byl úspěšně odeslán. Zkontrolujte prosím vaší
            emailovou schránku {{ majitel_firmy.email }}.
        </div>
        <div v-else class="row">
            <div class="col-12">
                <div class="row">
                    <div class="col-6">
                        <div class="pb-3">
                            <b>Tato firma je již registrovaná</b>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-6">
                        <a :href="firm.url">
                            <img id="firm_logo" :src="firm.getLogo" />
                        </a>
                    </div>
                    <div class="col-6">
                        <div id="firm_title">{{ firm.nazev }}</div>
                        <div v-for="email in firm.emails" :key="email">
                            <div>{{ email }}</div>
                        </div>
                        <div>{{ firm.telefon }}</div>
                        <div>
                            <b>{{ firm.adresa }}</b>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="pt-3">
                            <p>
                                Tato firma je registrovaná na email
                                {{ majitel_firmy.email }}. Přihlašte se pod
                                uvedeným emailem pro správu firmy. V případě, že
                                neznáte heslo, můžete provést jeho obnovení.
                            </p>
                            <button
                                class="button-02"
                                @click="getPrihlasseObnovitResponse"
                            >
                                Obnovit heslo
                            </button>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="pt-3">
                            <p>
                                V případě problémů s registrací nás prosím
                                <a :href="`mail:` + registrationEmail">
                                    kontaktujte
                                </a>
                                .
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-5">
            <div class="col-6 col-sm-2">
                <button
                    class="button-01"
                    @click="$store.commit('step/setStep', 'search')"
                >
                    Zpět
                </button>
            </div>
        </div>
    </div>
</template>

<script>
// import axios from 'axios';
// import PrihlasseApi from '../../../services/PrihlasseApi'
import FirmApi from '../../../services/FirmApi'

export default {
    name: 'FormWizardFirmClaim',
    data() {
        return {
            forgottenPasswordSent: false,
        }
    },
    computed: {
        firm() {
            return this.$store.state.claim.firm
        },
        registrationEmail() {
            return this.$store.state.config.registration_email
        },
        id_firmy() {
            return this.$store.state.claim.id_firmy
        },
        majitel_firmy() {
            return this.$store.state.claim.majitel_firmy
        },
    },
    beforeMount() {
        this.getDetail()
        this.getMajitelFirmy()
    },
    methods: {
        getDetail() {
            this.$store.dispatch('claim/fetchDetail', this.id_firmy)
        },
        getPrihlasseObnovitResponse() {
            let vm = this
            FirmApi.fetchForgottenPassword(this.majitel_firmy.email)
                .then(function(response) {
                    console.log(response)
                    vm.forgottenPasswordSent = true
                })
                .catch(function(error) {
                    console.log(error)
                })
            /*
            PrihlasseApi.fetchObnovitForm(this.majitel_firmy.email)
                .then(function(response) {
                    console.log(response)
                })
                .catch(function(error) {
                    console.log(error)
                })
            */
        },
        getMajitelFirmy() {
            this.$store.dispatch('claim/fetchMajitelFirmy', this.id_firmy)
        },
    },
}
</script>
